let default_domain = 'http://192.168.5.107:8080'; // 萌样本地域名
if (window.location.host.indexOf("mon-young.com") != -1 ) {
  default_domain = 'http://service.mon-young.com'
}
function request(method, ops) {
  var options = $.extend({
    url: "/",
    params: {},
    typeData: "json",
    contentType: undefined,
    domain: default_domain,
    callback: function (responseData) {
    },
  }, ops || {});
  $.ajax({
    type: method,
    url: options.domain + options.url,
    data: options.params,
    timeout: 15000,
    dataType: options.typeData,
    success: function (data) {
      options.callback(data);
    },
    error: function (xhr, status) {
      if (status === 'timeout') {
        alert("服务器响应超时！");
      } else if (xhr.status === 401) {
        location.hash = '/FirstPage';
        return;
      } else if (xhr.status > 0) {
        // alert(xhr.responseText);
        return;
      }
      // alert('请求“' + options.url + '”服务器没有响应！');
    },
    complete: function () {

    }
  });
}

export default class Request {
  constructor() {

  }

  get(options) {
    request('get', options);
  }

  post(options) {
    request('post', options);
  }

  put(options) {
    request('put', options);
  }

  delete(options) {
    request('delete', options);
  }
}



// WEBPACK FOOTER //
// ./src/common/request.js